import React from 'react';
import PropTypes from 'prop-types';

export const Element = props => {
    const {tagName, children, ...cleanProps} = props;
    return React.createElement(
        tagName,
        cleanProps,
        children
    );
};
    

Element.propTypes = {
    tagName: PropTypes.string.isRequired,
};

Element.defaultProps = {
    children: undefined,
};

export default Element;
